interface InlineSpanProps {
  children: React.ReactNode;
}

const InlineSpan = ({ children }: InlineSpanProps) => {
  return (
    <p className="text-[16px] !font-[B-Nazanin] inline-block text-president font-bold">
      {children}
    </p>
  );
};

export default InlineSpan;
